/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/guardrails/monitoring.actions'
import * as ActionTypes from '@src/redux/actionTypes/monitoring.action.types'
import { defaultState, MonitoringState } from './default.state'

export type MonitoringActionTypes = Actions.ActionTypes

export function reducer(
  state = defaultState,
  action: MonitoringActionTypes
): MonitoringState {
  switch (action.type) {
    case ActionTypes.GET_MONITORING_LIST_SUCCESS: {
      return {
        ...state,
        monitoringList: action.payload.monitoringList,
        isPending: false
      }
    }
    case ActionTypes.GET_MONITORING_LIST_FAIL: {
      return {
        ...state,
        error: action.payload.error,
        isPending: false
      }
    }
    case ActionTypes.CLEANER_STAT: {
      return {
        ...state,
        [action.payload.stat]: defaultState[action.payload.stat]
      }
    }
    case ActionTypes.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }
    case ActionTypes.DELETE_MONITOR_SUCCESS: {
      return {
        ...state,
        isPending: false
      }
    }
    case ActionTypes.DELETE_MONITOR_FAIL: {
      return {
        ...state,
        isPending: false,
        error: action.payload.error
      }
    }

    case ActionTypes.CREATE_MONITOR_SUCCESS: {
      return {
        ...state,
        isPending: false
      }
    }
    case ActionTypes.CREATE_MONITOR_FAIL: {
      return {
        ...state,
        isPending: false,
        error: action.payload.error
      }
    }

    case ActionTypes.SHOW_ONLY_ENABLED_GUARDRAILS: {
      return {
        ...state,
        showOnlyEnabledGuardrails: action.payload.flag
      }
    }

    default: {
      return state
    }
  }
}
